module.exports = __webpack_public_path__ + "img/emoney_mobile.5badd689.png";